import React, { useState} from 'react'
import AppNavbar from '../../components/Navbar'
import { Container, Card, Button, Form , Col, Row, Accordion} from 'react-bootstrap';
import {FaSearch} from 'react-icons/fa'
import search from '../../images/search.svg'
import { Link, useNavigate} from 'react-router-dom';
import Rectangle38 from '../../images/Rectangle38.svg'
import Heartadd from '../../images/heart-add.svg'
import Messagequestion from '../../images/message-question.png'
import { bookingFaq, activitiesFaq, accommodationFaq, flightFaq, allFaq } from '../../data';
import './faq.css'







const Faq = () => {
  const [selectedButton, setSelectedButton] = useState('');
  const [faq,setFaq] = useState(allFaq)
  const [seeAll, setSeeAll] = useState(false)
  const [searchText,setsearchText] = useState('');
  const handleSearch= (e) => {
    e.preventDefault();
    const gotText = searchText.toLowerCase();
   console.log(gotText)
    setFaq(
      faq.filter((fq) => {
        
       const newFaq = fq.question.toLowerCase().includes(gotText)

       
        
       console.log(newFaq)     
        return newFaq 
       

      })
    )
  
  }


  const handleButtonClick = (buttonIndex) => {
    setSelectedButton(buttonIndex);
    setFaq('')
    setSeeAll(true)
  };
  
  const handleAllFaq = () =>{
    setFaq(allFaq)
    setSelectedButton('')
    setSeeAll(false)
  }

  return (  
    <div>
        <AppNavbar/>
        <Container fluid style={{background:'#008080'}} className='justify-content-center align-items-center text-align-center p-4 my-3'>
      <Card style={{background:'none', borderRadius: 'none', maxWidth:'60rem'}}className='border-0 text-align-center p-3 p-md-5 m-auto my-4 '>
      <Card.Title className='acc-overlay-header align-items-center justify-content-center text-center text-white' style={{fontSize:'40px', fontWeight:'900', fontFamily: 'Nunito'}}>How can we help you today ?</Card.Title>
        
        <div className='mt-4'>
            <Form className='p-2 d-flex' style={{background:'#fff'}}>
           
              <img src={search} alt='search'/>
                <Form.Control type="text" placeholder="Ask your question" className='border-0' value={searchText}  onChange={(e) => {setsearchText(e.target.value)
              if(e.target.value === ''){
                setFaq(allFaq)
              }
            }
            }/>
            
                <Button onClick={handleSearch} style={{
 width: '100px',
 
 borderRadius: '8px',
 
 backgroundColor: '#008080'}} >Search</Button>
 
            </Form>
        </div>
        <Card.Text className='acc-overlay-info mt-4 align-items-center justify-content-center text-center'>
        Or choose a category to quickly find the help you need.
        </Card.Text>
      </Card>
    </Container>
    
    <Container className='mt-5'> 
    
        <div className='d-block d-sm-none mt-4'>
            <Row xs={2} className=' '>
              <Col className='mb-3 align-items-center justify-content-center'>
              <button className={selectedButton === 0 ? 'active-faq faq-button' : 'faq-button'} onClick={() => handleButtonClick(0)}>
            <img src={Heartadd}  alt='add' /> <br/>
            Bookings
            </button>
           
           
           
            </Col>
            <Col className='mb-3 align-items-center justify-content-center'>
            <button className={selectedButton === 1 ? 'active-faq faq-button' : 'faq-button'} onClick={() => handleButtonClick(1)} >
            <img src={Heartadd}  alt='add' /> <br/>
            Explore
            </button>
              </Col>
              <Col className=' align-items-center justify-content-center'>
              <button className={selectedButton === 2 ? 'active-faq faq-button' : 'faq-button'} onClick={() => handleButtonClick(2)} >
            <img src={Heartadd}  alt='add' /> <br/>
            Flights
            </button>
            </Col>
            <Col className='align-items-center justify-content-center'>
            <button className={selectedButton === 3 ? 'active-faq faq-button' : 'faq-button'} onClick={() => handleButtonClick(3)}>
            <img src={Heartadd}  alt='add' /> <br/>
            Accommodations
            </button>
              </Col>

            </Row>
           
           
        </div> 
       
       <div className='d-sm-flex d-none gap-lg-5 gap-md-3 mt-5 align-items-center justify-content-center'>
            
            <button className={selectedButton === 0 ? 'active faq-button' : 'faq-button'} onClick={() => handleButtonClick(0)} style={{width: '282px',height: '144px' ,top: '686px', borderRadius: '8px', backgroundColor: 'white', color:'black'}}>
            <img src={Heartadd}  alt='add' /> <br/>
            Bookings
            </button>
            <button className={selectedButton === 1 ? 'active faq-button' : 'faq-button'} onClick={() => handleButtonClick(1)} style={{width: '282px',height: '144px' ,top: '686px', borderRadius: '8px', backgroundColor: 'white', color:'black'}}>
            <img src={Heartadd}  alt='add' /> <br/>
            Explore
            </button>
            <button className={selectedButton === 2 ? 'active faq-button' : 'faq-button'} onClick={() => handleButtonClick(2)} style={{width: '282px',height: '144px' ,top: '686px', borderRadius: '8px', backgroundColor: 'white', color:'black'}}>
            <img src={Heartadd}  alt='add' /> <br/>
            Flights
            </button>
            <button className={selectedButton === 3 ? 'active faq-button' : 'faq-button'} onClick={() => handleButtonClick(3)} style={{width: '282px',height: '144px' ,top: '686px', borderRadius: '8px', backgroundColor: 'white', color:'black'}}>
            <img src={Heartadd}  alt='add' /> <br/>
            Accommodations
            </button>



            
           </div>
        </Container>
        <div className='py-5 px-2 my-4'>
        {seeAll && ( <p className='forgot-password text-center mb-5' style={{fontSize:'20px'}} onClick={handleAllFaq}>See all FAQs</p>)}
          
      {faq && (
         <div className="">
         <div className='d-flex flex-column  align-items-center gap-2 saved-information '>
         <h5 className='text-center'>FAQs</h5>


 <Accordion>
 {
     faq.map((fq)=> {
       const {id,question,answer} = fq;
       return (
         <Accordion.Item eventKey={id} key={id}>
         <Accordion.Header>
           <img src={Messagequestion} alt="message-icon" className="right me-2" />
          {question}
         </Accordion.Header>
         <Accordion.Body>
           {answer}
         </Accordion.Body>
       </Accordion.Item>
       )
     })
   }
   
 </Accordion>
           
         </div>
       </div>
      )}

        {selectedButton === 0 && (
              <div className="">
                <div className='d-flex flex-column  align-items-center gap-2 saved-information '>
                <h5 className='text-center'>Bookings</h5>
        <p className='text-center'>Offer a wide range of accommodation options such as hotels, resorts, and vacation rentals</p>

        <Accordion>
        {
            bookingFaq.map((booking)=> {
              const {id,question,answer} = booking;
              return (
                <Accordion.Item eventKey={id} key={id}>
                <Accordion.Header>
                  <img src={Messagequestion} alt="message-icon" className="right me-2" />
                 {question}
                </Accordion.Header>
                <Accordion.Body>
                  {answer}
                </Accordion.Body>
              </Accordion.Item>
              )
            })
          }
          
        </Accordion>
                  
                </div>
              </div>
        )}      

        {selectedButton === 1 && (
             <div className="">
             <div className='d-flex flex-column  align-items-center gap-2 saved-information '>
             <h5 className='text-center'>Explore</h5>
     <p className='text-center'>You can explore different tour destinations and popular places to visit</p>

     <Accordion>
     {
         activitiesFaq.map((activity)=> {
           const {id,question,answer} = activity;
           return (
             <Accordion.Item eventKey={id} key={id}>
             <Accordion.Header>
               <img src={Messagequestion} alt="message-icon" className="right me-2" />
              {question}
             </Accordion.Header>
             <Accordion.Body>
               {answer}
             </Accordion.Body>
           </Accordion.Item>
           )
         })
       }
       
     </Accordion>
               
             </div>
           </div>
        )}

{selectedButton === 2 && (
              <div className="">
              <div className='d-flex flex-column  align-items-center gap-2 saved-information '>
              <h5 className='text-center'>Flights</h5>
      <p className='text-center'>Offer good flight deals while you book a flight to your destination</p>
 
      <Accordion>
      {
          flightFaq.map((flight)=> {
            const {id,question,answer} = flight;
            return (
              <Accordion.Item eventKey={id} key={id}>
              <Accordion.Header>
                <img src={Messagequestion} alt="message-icon" className="right me-2" />
               {question}
              </Accordion.Header>
              <Accordion.Body>
                {answer}
              </Accordion.Body>
            </Accordion.Item>
            )
          })
        }
        
      </Accordion>
                
              </div>
            </div>
        )}
{selectedButton === 3 && (
              <div className="">
              <div className='d-flex flex-column  align-items-center gap-2 saved-information '>
              <h5 className='text-center'>Accommodation</h5>
      <p className='text-center'>Offer a wide range of hotels depending on your location</p>
 
      <Accordion>
      {
          accommodationFaq.map((accommodation)=> {
            const {id,question,answer} = accommodation;
            return (
              <Accordion.Item eventKey={id} key={id}>
              <Accordion.Header>
                <img src={Messagequestion} alt="message-icon" className="right me-2" />
               {question}
              </Accordion.Header>
              <Accordion.Body>
                {answer}
              </Accordion.Body>
            </Accordion.Item>
            )
          })
        }
        
      </Accordion>
                
              </div>
            </div>
        )}
        



        




       

    

    

    



    </div>
    </div>
  );
};

export default Faq;
